import { useState } from 'react';

import { useReviewNotice } from '../../hooks';
import ReviewNoticeRow from './ReviewNoticeRow';

export default function ReviewNoticeList() {
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const { data, isSuccess } = useReviewNotice();

  return isSuccess && !!data ? (
    <>
      {data.map((notice) => (
        <ReviewNoticeRow
          key={notice.id}
          isExpanded={notice.id === selectedId}
          onToggle={() => setSelectedId(selectedId !== notice.id ? notice.id : null)}
          {...notice}
        />
      ))}
    </>
  ) : null;
}
